export default __webpack_public_path__ + "static/media/support.343d5db5.svg";